import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { useQuery } from 'react-query';
import { PhoneNumbersPageResponse } from 'types/phoneNumber';
import phoneNumberQueryKeys from './phoneNumberQueryKeys';

export const useListPhoneNumbersQuery = (
  skip: number,
  take: number,
  orderBy: any,
  filters: any,
) => {
  // returns list of phoneNumbers
  // - just get ALL phoneNumbers+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = phoneNumberQueryKeys.list(skip, take, orderBy, filters);

  const query = useQuery<PhoneNumbersPageResponse, Error>(
    queryKey,
    () =>
      sdk.phoneNumber.query.phoneNumbers(
        {
          skip,
          take,
          orderBy,
          filters,
        },
        { authToken: authState.auth_token },
      ),
    {
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,

      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      keepPreviousData: true,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useListPhoneNumbersQuery;
